import { gql } from '@apollo/client';

// Single query that accepts an array of tickers using _in operator
export const GET_INSTRUMENTS_BY_TICKERS = gql`
  query GetInstrumentsByTickers($tickers: [String!]!) {
    EQInstrument(where: { full_ticker: { _in: $tickers } }) {
      id
      ticker
      full_ticker
      name
      isin
      sector
      currency
      exchange
      companyId
    }
  }
`;

// Query to get a single instrument by ISIN
export const GET_INSTRUMENT_BY_ISIN = gql`
  query GetInstrumentByISIN($isin: String!) {
    EQInstrument(where: { isin: { _eq: $isin } }) {
      id
      ticker
      full_ticker
      name
      isin
      sector
      currency
      exchange
      companyId
    }
  }
`;
